import { Outlet } from 'react-router-dom';
import Sidebar from '../components/sidebar/Sidebar';
import ValidateSession from '../components/ValidateSession';
import Theme from '../components/Theme';
import Header from '../components/Header/index';
import './BaseLayout.scss';

const BaseLayout = () => {
	return (
		<ValidateSession>
			<div className='base-layout'>
				<Header />
				<div className='layout-body'>
					<Sidebar />
					<div className='layout-content'>
						<Outlet />
					</div>
				</div>
				<Theme />
			</div>
		</ValidateSession>
	);
};

export default BaseLayout;
